<template>
  <tr>
    <td>
      <div class="c-product-card type-horizontal type-checkbox">
        <div class="c-checkbox type-small">
          <input
            type="checkbox"
            :id="'basket-chk-' + index"
            name="basket-group1"
            :checked="checkedValue"
            @change="toggleItem()"
          />
          <label :for="'basket-chk-' + index">
            <span class="sr-only">상품선택</span>
          </label>
        </div>
        <div class="product-thumb">
          <button
            type="button"
            class="thumb-button"
            @click="openProdInfoPop(item)"
          >
            <div class="product-img">
              <img
                class="no-image"
                v-if="isNoPcImage"
                src="@/assets/images/common/img_no_product.svg"
                alt="No Image"
              />
              <img
                v-else
                :src="imageFilePath"
                alt=""
                @error="() => (imageErrorYn = true)"
              />
            </div>
            <div class="thumb-bottom">
              <p class="text">제품상세</p>
              <i class="c-icon icon-plus"></i>
            </div>
          </button>
        </div>
        <div class="product-info">
          <div v-show="!productBadgeEmptyYn" class="c-product-badge">
            <span v-if="item.setgdYn === 'Y'" class="badge type-skyblue">
              SET 제품
            </span>

            <span v-if="item.zzlqdCls == 'A'" class="badge type-purple">
              주제
            </span>
            <span v-if="item.zzlqdCls == 'B'" class="badge type-mint">
              경화제
            </span>
            <span v-if="item.zzlqdCls == 'C'" class="badge type-blue">
              경화촉진제
            </span>
            <span v-if="item.zzlqdCls == 'D'" class="badge type-violet">
              회석제
            </span>

            <span v-if="item.zzlqdtyCls == 'A'" class="badge type-olive">
              1액형
            </span>
            <span v-if="item.zzlqdtyCls == 'B'" class="badge type-olive">
              2액형
            </span>
            <span v-if="item.zzlqdtyCls == 'C'" class="badge type-olive">
              3액형
            </span>
          </div>
          <div class="c-product-category">
            <span class="path">{{ item.prodh1t }}</span>
            <span class="path">{{ item.prodh2t }}</span>
            <span class="path">{{ item.prodh3t }}</span>
          </div>
          <div class="product-code">{{ item.matnr }}</div>
          <strong class="product-name">{{ item.zzmaktx }}</strong>
        </div>
      </div>
    </td>
    <td class="ac">{{ item.zztotalQty }}</td>
    <td class="ac">
      <div class="c-counter">
        <button
          type="button"
          class="btn-minus"
          :disabled="item.goodsQty <= 1"
          @click="() => item.goodsQty--"
        >
          <i class="c-icon icon-minus size-xxsmall"></i>
          <span class="sr-only">빼기</span>
        </button>
        <input
          type="number"
          title="수량입력"
          v-model="item.goodsQty"
          ref="myInput"
          @mousedown="handleMouseDown"
        />
        <button type="button" class="btn-plus" @click="() => item.goodsQty++">
          <i class="c-icon icon-plus-black size-xxsmall"></i>
          <span class="sr-only">더하기</span>
        </button>
      </div>
    </td>
    <td class="ar">
      {{ Number(item.kbetr * item.goodsQty).toLocaleString() }}원
    </td>
    <td class="ac">
      <div class="button-box">
        <button
          type="button"
          class="c-util-button type-line-black type-small"
          ref="keepButtonRef"
          data-popover-trigger="basket1"
          @mouseenter="keepButtonPopover"
          @mouseleave="() => (isShowKeepButtonPopover = false)"
          @click="keepItem(item)"
        >
          <span v-if="item.cntsStrgYn === 'Y'">계속담기취소</span>
          <span v-else>계속담아두기</span>
        </button>
        <div
          class="c-popover-detail type-small"
          data-popover-trigger="basket1"
          :class="{ 'is-active': isShowKeepButtonPopover }"
          :style="{
            position: 'fixed',
            top: keepButtonPopoverStyle.top + 'px',
            left: keepButtonPopoverStyle.left + 'px',
          }"
        >
          <div class="text">
            제품을 장바구니에 <br />
            계속 보관할 수 있습니다.
          </div>
        </div>
        <button
          type="button"
          class="c-util-button type-primary type-small"
          @click.stop="() => emit('ordertemp', item)"
        >
          <span>바로주문</span>
        </button>
      </div>
    </td>
  </tr>
</template>

<script setup>
import { onMounted, ref, defineProps, defineEmits, computed, watch } from "vue";
// import * as cmUtil from "@/utils/cmUtil";
import * as cmApi from "@/api/cmApi";
import Utils from "@/js/utils";

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
  index: {
    type: Number,
    require: true,
  },
  checked: {
    type: Boolean,
    require: true,
  },
});

const emit = defineEmits(["checked", "detail", "ordertemp"]);

const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
const item = ref(props.item); // 제품
const imageErrorYn = ref(false);
const checkedValue = computed({
  get: () => props.checked,
  set: (value) => emit("checked", value),
});
const myInput = ref(null);

onMounted(() => {});

watch(
  () => props.item,
  (newValue) => {
    item.value = newValue;
  }
);

// 제품 상세 팝업
function openProdInfoPop(item) {
  emit("detail", item);
}

// 제품 수량 입력
watch(
  () => item.value.goodsQty,
  (newQty, oldQty) => {
    if (newQty < 1) {
      item.value.goodsQty = 1;
    } else if (newQty > 99999) {
      item.value.goodsQty = oldQty;
    } else {
      item.value.goodsQty = newQty;
    }
    updateItemQuantity(item.value.goodsSn, item.value.goodsQty);
  }
);

// 제품 수량 변경 API
async function updateItemQuantity(goodsSn, goodsQty) {
  const param = {
    goodsSn: goodsSn,
    goodsQty: goodsQty,
    cntsStrgYn: item.value.cntsStrgYn,
  };
  await cmApi.updateUserBasketProd(param);
}

// 계속담아두기
async function keepItem(item) {
  item.cntsStrgYn = item.cntsStrgYn === "Y" ? "N" : "Y";
  const param = {
    goodsSn: item.goodsSn,
    goodsQty: item.goodsQty,
    cntsStrgYn: item.cntsStrgYn,
  };
  await cmApi.updateUserBasketProd(param);
}

// 체크박스
function toggleItem() {
  checkedValue.value = !checkedValue.value;
}

const keepButtonRef = ref();
const keepButtonPopoverStyle = ref({
  top: 1000,
  left: 2000,
});
const isShowKeepButtonPopover = ref(false);

const keepButtonPopover = () => {
  keepButtonPopoverStyle.value.top =
    keepButtonRef.value.getBoundingClientRect().top - 70;
  keepButtonPopoverStyle.value.left =
    keepButtonRef.value.getBoundingClientRect().left - 33;

  isShowKeepButtonPopover.value = true;
};

const productBadgeEmptyYn = computed(() => {
  return (
    item.value.setgdYn !== "Y" &&
    item.value.zzlqdCls !== "A" &&
    item.value.zzlqdCls !== "B" &&
    item.value.zzlqdCls !== "C" &&
    item.value.zzlqdCls !== "D" &&
    item.value.zzlqdtyCls !== "A" &&
    item.value.zzlqdtyCls !== "B" &&
    item.value.zzlqdtyCls !== "C"
  );
});

const isNoPcImage = computed(() => {
  return (
    Utils.isBlank(item.value.filePath) ||
    Utils.isBlank(item.value.physFileNm) ||
    imageErrorYn.value
  );
});

const imageFilePath = computed(() => {
  return FILE_CDN_URL + "/" + item.value.filePath + "/" + item.value.physFileNm;
});

const handleMouseDown = (event) => {
  event.preventDefault();
  myInput.value?.focus();
  myInput.value?.select();
};
</script>
